import { render, staticRenderFns } from "./uploadone.vue?vue&type=template&id=4c435f91&scoped=true&"
import script from "./uploadone.vue?vue&type=script&lang=js&"
export * from "./uploadone.vue?vue&type=script&lang=js&"
import style0 from "./uploadone.vue?vue&type=style&index=0&id=4c435f91&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c435f91",
  null
  
)

export default component.exports